document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('a[href]').forEach((linkEl) => {
    if (linkEl.hostname !== location.hostname) {
      linkEl.target = '_blank';
    }
  });
});

document.addEventListener("DOMContentLoaded", function(event) { 

  console.log('yes');
  const throttled = (delay, fn) => {
    let lastCall = 0;
    console.log('yes 2');
    return function (...args) {
      const now = new Date().getTime();
      if (now - lastCall < delay) {
        return;
      }
      lastCall = now;
      return fn(...args);
    };
  };

const movableElementsWrapper = document.querySelector(
  ".movable-elements-wrapper"
);
  
const speed = 0.35;

const items = gsap.utils.toArray(".movable").map(element => {
  return {
    element,
    shiftValue: element.getAttribute("data-value") / 250,
    xSet: gsap.quickSetter(element, "x", "px"),
    ySet: gsap.quickSetter(element, "y", "px"),
  }
});

const mouse = {
  x: 0,
  y: 0
};

const mouseMoveHandler = (e) => {
  mouse.x = e.x;
  mouse.y = e.y;
};

});



